module.exports = new __parcel__URL__("avatar-letter-a.a574ddda.png").toString();